export const EHotelStatus = {
   0: "UNKNOWN",
   1: "ACTIVE",
   2: "PASSIVE",
   "-1": "ALL",
};

export const EHtlMapingType = {
   0: "UNKNOWN",
   1: "HOTEL",
   2: "LOCATION",
   3: "BOARD_TYPE",
   5: "FACILITY",
   "-1": "ALL",
};

export const EHtlMapingStatus = {
   0: "UNKNOWN",
   1: "NEW",
   2: "MAPPED",
   3: "WONT_MAP",
   4: "NOT_PRESENT",
   5: "SUSPENDED",
   6: "UNMAPPED",
   "-1": "ALL",
};

export const EHotelRegion = {
   0: "UNKNOWN",
   1: "ANTALYA",
   2: "AEGEAN",
   3: "ISTANBUL",
   4: "ANATOLIAN",
   5: "REST_OF_THE_WORLD",
   "-1": "ALL",
};

export const EHtlGuestType = {
   0: "UNKNOWN",
   1: "ADULT",
   2: "CHILD",
   "-1": "ALL",
};

export const EHtlVoucherStatus = {
   0: "UNKNOWN",
   1: "NEW",
   2: "RESERVED",
   3: "BOOKED",
   4: "CANCELED",
   5: "VOIDED",
   6: "REFUNDED",
   7: "REBOOKED",
   8: "ERROR",
   10: "PENDING_BOOKED",
   11: "PENDING_RESERVED",
   12: "PENDING_CANCELED",
   13: "PENDING_VOIDED",
   14: "PENDING_REFUNDED",
   15: "PARTIAL_PAID",
   "-1": "ALL",
};

export const EHtlRoomPriceStatus = {
   0: "UNKNOWN",
   1: "NEW",
   2: "RESERVED",
   3: "BOOKED",
   4: "CANCELED",
   5: "VOIDED",
   6: "REFUNDED",
   7: "REBOOKED",
   8: "ERROR",
   10: "PENDING_BOOKED",
   11: "PENDING_RESERVED",
   12: "PENDING_CANCELED",
   13: "PENDING_VOIDED",
   14: "PENDING_REFUNDED",
   15: "PARTIAL_PAID",
   "-1": "ALL",
};

export const EHtlAddOnStatus = {
   0: "UNKNOWN",
   1: "NEW",
   2: "RESERVED",
   3: "BOOKED",
   4: "CANCELED",
   5: "VOIDED",
   6: "REFUNDED",
   7: "REBOOKED",
   8: "ERROR",
   "-1": "ALL",
};

export const EHtlImportType = {
   0: "UNKNOWN",
   1: "AUTO",
   2: "MANUAL",
   "-1": "ALL",
};

export const EHtlAmountType = {
   0: "UNKNOWN",
   1: "RATIO",
   2: "FIXED",
   "-1": "ALL",
};

export const EHtlPolicyType = {
   0: "UNKNOWN",
   1: "CANCELLATION",
   2: "NO_SHOW",
   "-1": "ALL",
};

export const EHtlCommissionType = {
   0: "UNKNOWN",
   1: "GTS",
   2: "GSA",
   3: "AGENCY",
   "-1": "ALL",
};

export const EHtlCommissionRatioType = {
   0: "UNKNOWN",
   1: "COMMISION",
   2: "MARKUP",
   "-1": "ALL",
};

export const EHtlSearchType = {
   0: "UNKNOWN",
   1: "LOCATION",
   2: "HOTEL",
   "-1": "ALL",
};

export const EHtlContentUpdateType = {
   0: "UNKNOWN",
   1: "OVERWRITE_ANY_WAY",
   2: "OVERWRITE_NOT_EDITED",
   3: "OVERWRITE_WITH_CONFIRM",
   "-1": "ALL",
};

export const EHtlContentItemStatus = {
   0: "UNKNOWN",
   1: "NEW",
   2: "CONFIRMED",
   3: "CONFIRMED_EDITED",
   4: "DELETED",
   "-1": "ALL",
};

export const EHtlHotelVerifyStatus = {
   0: "UNKNOWN",
   1: "NOT_PATTERNIZED",
   2: "PATTERNIZED",
   3: "VERIFIED",
   "-1": "ALL",
};

export const EHtlOptionNotifyStatus = {
   0: "UNKNOWN",
   1: "NOTIFIED",
   2: "FAILED_TO_NOTIFY",
   "-1": "ALL",
};

export const EHtlImageCategory = {
   0: "UNKNOWN",
   1: "GENERAL",
   2: "ROOM",
   3: "EXTERIOR",
   4: "BAR",
   5: "SPORT",
   6: "CONFERENCE",
   7: "LOBBY",
   8: "POOL",
   9: "RESTAURANT",
   10: "BEACH",
   11: "TERRACE",
   12: "ACCOMMODATION",
   "-1": "ALL",
};

export const EHtlVoucherReverseEnabledType = {
   0: "UNKNOWN",
   1: "NON_REFUNDABLE",
   2: "REFUNDABLE_WO_PENALTY",
   3: "REFUNDABLE_WITH_PENALTY",
   4: "ALREADY_REVERSED",
   "-1": "ALL",
};

export const EHtlAmountForceType = {
   0: "UNKNOWN",
   1: "FREE_COMM",
   2: "FORCED_CONST_COMM",
   3: "FORCED_MAX_COMM",
   4: "FORCED_MIN_COMM",
   "-1": "ALL",
};

export const EHtlRefundType = {
   0: "UNKNOWN",
   1: "REFUNDABLE",
   2: "NONREFUNDABLE",
   "-1": "ALL",
};

export const EHtlPriceViewType = {
   0: "UNKNOWN",
   1: "NOT_SHOW_PROVIDER_BREAKDOWN",
   2: "SHOW_PROVIDER_BREAKDOWN",
   "-1": "ALL",
};

export const EHtlPaymentType = {
   0: "UNKNOWN",
   1: "ENETT",
   2: "TRANSFER",
   "-1": "ALL",
};

export const EHtlPaymentStatus = {
   0: "UNKNOWN",
   1: "NO_DEPOSIT",
   2: "EB_DEPOSIT",
   3: "EB_WITHDRAWAL",
   4: "FULL_DEPOSIT",
   5: "FULL_WITHDRAWAL",
   6: "NOT_PAID",
   7: "CANCELED",
   "-1": "ALL",
};

export const EHotelContactTitle = {
   0: "UNKNOWN",
   1: "GENERAL_MANAGER",
   2: "ASSISTANT_GENERAL_MANAGER",
   3: "SALES_MANAGER",
   4: "INCOMING_MANAGER",
   5: "FRONT_OFFICE_MANAGER",
   6: "RESERVATION_MANAGER",
   7: "ACCOUNTING_MANAGER",
   8: "OTHER",
   "-1": "ALL",
};

export const EHtlFacilityType = {
   0: "UNKNOWN",
   1: "HOTEL",
   2: "ROOM",
   3: "HOTEL_AND_ROOM",
   "-1": "ALL",
};

export const EHtlBedType = {
   0: "UNKNOWN",
   1: "SINGLE",
   2: "DOUBLE",
   3: "TWIN",
   4: "DOUBLE_OR_TWIN",
   5: "KING",
   6: "QUEEN",
   7: "FRENCH",
   8: "BUNK",
   9: "SOFA",
   "-1": "ALL",
};

export const EHtlRoomGroup = {
   0: "UNKNOWN",
   1: "ECONOMY",
   2: "STANDARD",
   3: "COMFORT",
   4: "BUSINESS",
   5: "SUPERIOR",
   6: "DELUXE",
   7: "PREMIER",
   8: "EXECUTIVE",
   9: "PRESIDENTIAL",
   10: "PREMIUM",
   11: "CLASSIC",
   12: "AMBASSADOR",
   13: "GRAND",
   14: "LUXURY",
   15: "PLATINUM",
   16: "PRESTIGE",
   17: "PRIVILEGE",
   18: "ROYAL",
   19: "SUITE",
   20: "SWIM_UP",
   21: "VILLA",
   "-1": "ALL",
};

export const EHtlStopType = {
   0: "UNKNOWN",
   1: "OPEN",
   2: "STOP",
   3: "CHECKIN_BASED_STOP",
   "-1": "ALL",
};

export const EHtlPenaltyType = {
   0: "UNKNOWN",
   1: "RATIO",
   2: "DAY",
   "-1": "ALL",
};

export const EHtlPriceRestrictionType = {
   0: "UNKNOWN",
   1: "NO_RESTRICTION",
   2: "MIN_STAY",
   3: "STOP",
   4: "RELEASE",
   5: "QUOTA",
   "-1": "ALL",
};

export const EHtlNoteType = {
   0: "UNKNOWN",
   1: "NOTE",
   2: "LABEL",
   "-1": "ALL",
};

export const EHtlNoteSubType = {
   0: "UNKNOWN",
   101: "NOTE_HOTEL_NOTE",
   102: "NOTE_HOTEL_DESCRIPTION",
   201: "LABEL_MR_STAY",
   202: "LABEL_HOTEL_CLOSED",
   203: "LABEL_PARTIAL_PAYMENT",
   "-1": "ALL",
};

export const EHtlPageType = {
   0: "UNKNOWN",
   1: "SEARCH",
   2: "CHECKOUT",
   3: "ORDER_DETAIL",
   4: "SEARCH_HOTEL_DETAIL",
   5: "SEARCH_ROOM_DETAIL",
   6: "VOUCHER_DOCUMENT",
   "-1": "ALL",
};

export const EHtlSpoType = {
   0: "UNKNOWN",
   1: "PERCENTAGE_DISCOUNT",
   2: "DAY_DISCOUNT",
   3: "FIXED_PRICE_DISCOUNT",
   4: "CHILD_DISCOUNT",
   5: "KICKBACK_DISCOUNT",
   "-1": "ALL",
};

export const EHtlSpoFreeDayType = {
   0: "UNKNOWN",
   1: "START_FROM_CHECKIN",
   2: "START_FROM_CHECKOUT",
   3: "CHEAPEST_DAY",
   4: "MOST_EXPENSIVE_DAY",
   5: "AVERAGE_PRICE",
   "-1": "ALL",
};

export const EHtlContentImportType = {
   0: "UNKNOWN",
   1: "HOTEL_NAME",
   "-1": "ALL",
};

export const EHtlKickbackType = {
   0: "UNKNOWN",
   1: "REFLECT_NET",
   2: "REFLECT_SALE",
   "-1": "ALL",
};

export const EHtlContractType = {
   0: "UNKNOWN",
   1: "GTS",
   2: "CHANNEL_MANAGER",
   "-1": "ALL",
};

export const EHtlHotelStarCategory = {
   0: "UNKNOWN",
   1: "STAR",
   2: "SPECIAL_CATEGORY",
   3: "BOUTIQUE_HOTEL",
   "-1": "ALL",
};

export const EHtlSpoCumulateType = {
   0: "UNKNOWN",
   1: "WITH_KICKBACK",
   2: "WITHOUT_KICKBACK",
   3: "CUMULATE_WITH_KICKBACK",
};

export const EHtlSearchCacheSyncType = {
   0: "UNKNOWN",
   1: "AUTO",
   2: "MANUEL",
   "-1": "ALL",
};

export const EHtlSearchCacheSyncStatus = {
   0: "UNKNOWN",
   1: "CHANGED",
   2: "UPLOADING",
   3: "UPLOADED",
   4: "CACHING",
   5: "CACHED",
   6: "ERROR",
   "-1": "ALL",
};

export const EHtlChildType = {
   0: "UNKNOWN",
   1: "CHILD1",
   2: "CHILD2",
   "-1": "ALL",
};

export const EHtlContractSettingsType = {
   0: "UNKNOWN",
   1: "CONTRACTOR",
   2: "BOARD_TYPE",
   3: "PAYMENT_TYPE",
   4: "LABEL",
   5: "PRICE",
   6: "ROOM",
   7: "MARKET",
   8: "CHANNEL_MANAGER",
   "-1": "ALL",
};

export const EHtlPriceBlockStatus = {
   0: "UNKNOWN",
   1: "PASSIVED",
   2: "DELETED",
   "-1": "ALL",
};
